// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_2ImXo","icon":"index_icon_v8r4Y","title":"index_title_2RG7r","line":"index_line_36YNc"};